// Utilities for handling requestValidTill countdown storage and updates

const STORAGE_KEY = 'requestValidTill';
const UPDATE_EVENT = 'requestValidTillUpdated';

export const setRequestValidTill = (isoString) => {
  try {
    if (isoString) {
      localStorage.setItem(STORAGE_KEY, isoString);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
    // Notify listeners that the requestValidTill has changed
    if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
      window.dispatchEvent(new CustomEvent(UPDATE_EVENT, { detail: { isoString } }));
    }
  } catch (e) {
    // no-op: localStorage may be unavailable
  }
};

export const getRequestValidTill = () => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch (e) {
    return null;
  }
};

export const getRemainingMs = () => {
  const iso = getRequestValidTill();
  if (!iso) return 0;
  const expiry = new Date(iso).getTime();
  const now = Date.now();
  const diff = expiry - now;
  return diff > 0 ? diff : 0;
};

export const getRemainingParts = () => {
  const ms = getRemainingMs();
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return { minutes, seconds };
};

export const formatRemaining = () => {
  const { minutes, seconds } = getRemainingParts();
  const mm = String(minutes).padStart(2, '0');
  const ss = String(seconds).padStart(2, '0');
  return `${mm}:${ss}`;
};

// Starts a 1s interval and calls onTick with ({ ms, minutes, seconds, formatted })
// Returns a disposer function to stop the countdown
export const startRequestValidTillCountdown = (onTick, onExpire) => {
  let intervalId = null;

  const tick = () => {
    const ms = getRemainingMs();
    const { minutes, seconds } = getRemainingParts();
    const formatted = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    if (typeof onTick === 'function') {
      onTick({ ms, minutes, seconds, formatted });
    }
    if (ms <= 0) {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
      if (typeof onExpire === 'function') {
        onExpire();
      }
    }
  };

  // Reset/restart countdown when requestValidTill is updated
  const handleUpdated = () => {
    if (intervalId) {
      clearInterval(intervalId);
    }
    intervalId = setInterval(tick, 1000);
    tick();
  };

  // Start immediately
  intervalId = setInterval(tick, 1000);
  tick();

  // Listen to updates
  if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
    window.addEventListener(UPDATE_EVENT, handleUpdated);
  }

  // Return cleanup function
  return () => {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
    if (typeof window !== 'undefined' && typeof window.removeEventListener === 'function') {
      window.removeEventListener(UPDATE_EVENT, handleUpdated);
    }
  };
};


